var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{class:["q-ma-sm", _vm.valueInternal],attrs:{"round":"","readonly":true},on:{"click":function($event){return _vm.toggleGroup()}}},[_vm._v(_vm._s(_vm.shortName))])}
var staticRenderFns = []

export { render, staticRenderFns }